import { Theme, Components } from '@mui/material/styles';

export const DialogOverrides: Components<Theme> = {
  MuiBackdrop: {
    defaultProps: {},
    styleOverrides: {
      root: () => ({
        backgroundColor: 'rgba(17, 49, 154, 0.8)', // Adjust the color as needed
        '&.MuiBackdrop-invisible': {
          backgroundColor: 'transparent', // Make invisible backdrop transparent
        },
      }),
    },
  },
  MuiDialog: {
    defaultProps: {},
    styleOverrides: {
      paper: {
        borderRadius: 0, // or whatever radius you want
      },
    },
  },
  MuiDialogContent: {
    defaultProps: {},
    styleOverrides: {},
  },
  MuiDialogActions: {
    defaultProps: {},
    styleOverrides: {
      root: ({ theme }) => ({
        paddingTop: theme.spacing(2),
        paddingLeft: theme.spacing(3),
        paddingBottom: theme.spacing(2),
        paddingRight: theme.spacing(3),
      }),
    },
  },
};
